import { Controller } from "@hotwired/stimulus"

// Progressive enhancement for the Article 50 assessment. Without JS the form
// still works: every question is visible and the server validates. With JS the
// two follow-up questions appear only when their parent answer makes them
// relevant, the PDF form gets its js_check token, and the print button works.
export default class extends Controller {
  static targets = ["conditional", "jsCheck"]

  connect() {
    this.jsCheckTargets.forEach((input) => (input.value = "js_enabled"))
    this.refresh()
  }

  // Fired on any change inside the form (see data-action on the form tag).
  refresh() {
    this.conditionalTargets.forEach((block) => {
      const { parentName, parentValue } = block.dataset
      const checked = this.element.querySelector(
        `input[name="${parentName}"]:checked`
      )
      const show = Boolean(checked) && checked.value === parentValue

      block.hidden = !show
      block.querySelectorAll("input").forEach((input) => {
        input.required = show
        if (!show) input.checked = false
      })
    })
  }

  print() {
    window.print()
  }
}
